export default "__VITE_ASSET__DrDU9wBR__"